import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ds-modal-alert__code"
}

import { computed, getCurrentInstance, nextTick, onMounted, ref } from "vue";
import { DsModalAlertModel } from "./ds-modal-alert-model";
import DsButton from "../button/ds-button.vue";
import WebpImage from "../image/webp-image.vue";
import DsModalDialog from "../modal-dialog/ds-modal-dialog.vue";
import DsTopSlotHeadlineSubheadline from "../top-slot/ds-top-subheadline.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ds-modal-alert',
  props: {
    title: {},
    subText: {},
    errorCode: {},
    animate: { type: Boolean, default: true },
    bottomDividerVisible: { type: Boolean, default: false },
    alertImageSrc: { default: null },
    modalClass: {},
    btnCloseText: { default: "OK" },
    btnCloseClass: {},
    btnCloseType: { default: "primary" },
    btnConfirmText: {},
    btnConfirmHref: {},
    btnConfirmType: { default: "primary" },
    btnConfirmClickHandler: {},
    buttonsFlexDirection: { default: "column" },
    isWide: { type: Boolean, default: false }
  },
  setup(__props: any) {

const app = getCurrentInstance();

const props = __props;

const isVisible = ref(props.animate ? false : true);

onMounted(() => {
    if (props.animate) {
        nextTick(() => {
            isVisible.value = true;
        });
    }
});

const handleModalClosed = () => {
    isVisible.value = false;

    nextTick(() => {
        app.appContext.app.unmount();
    });
};

const ctaClickHandler = () => {
    if (props.btnConfirmClickHandler) {
        props.btnConfirmClickHandler();
    }

    handleModalClosed();
};

const modalClasses = computed(() => {
    const classes = [props.modalClass, "ds-modal-alert"];
    if (props.isWide) {
        classes.push("ds-modal-alert--wide");
    }

    return classes;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsModalDialog, {
    "model-value": isVisible.value,
    "top-divider-visible": false,
    "bottom-divider-visible": _ctx.bottomDividerVisible,
    "has-dialog-close-btn": false,
    "onUpdate:modelValue": handleModalClosed,
    animate: _ctx.animate,
    "css-class": modalClasses.value
  }, {
    top: _withCtx(() => [
      (_ctx.alertImageSrc)
        ? (_openBlock(), _createBlock(WebpImage, {
            key: 0,
            alt: "Error kuličník",
            src: '/frontend/web' + _ctx.alertImageSrc,
            width: "148",
            height: "80",
            "css-class": "ds-modal-alert__image",
            class: "ds-modal-alert__picture"
          }, null, 8, ["src"]))
        : _createCommentVNode("", true),
      _createVNode(DsTopSlotHeadlineSubheadline, {
        headline: _ctx.title,
        subheadline: _ctx.subText
      }, null, 8, ["headline", "subheadline"])
    ]),
    bottom: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["ds-modal-alert__buttons", [
                    `ds-modal-alert__buttons--${_ctx.buttonsFlexDirection}`,
                    { 'ds-modal-alert__buttons--no-margin': _ctx.bottomDividerVisible },
                ]])
      }, [
        (_ctx.btnConfirmText)
          ? (_openBlock(), _createBlock(DsButton, {
              key: 0,
              href: _ctx.btnConfirmHref,
              class: "ds-modal-alert__button",
              type: _ctx.btnConfirmType,
              onClick: ctaClickHandler
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.btnConfirmText), 1)
              ]),
              _: 1
            }, 8, ["href", "type"]))
          : _createCommentVNode("", true),
        _createVNode(DsButton, {
          class: _normalizeClass(["ds-modal-alert__button", _ctx.btnCloseClass]),
          onClick: handleModalClosed,
          type: _ctx.btnCloseType
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.btnCloseText), 1)
          ]),
          _: 1
        }, 8, ["class", "type"])
      ], 2),
      (_ctx.errorCode)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "ecode: " + _toDisplayString(_ctx.errorCode), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value", "bottom-divider-visible", "animate", "css-class"]))
}
}

})